import { auth } from "@/config/firebase";
import { isAdminToken, parseClaims } from "./claims";

/**
 * Bind a pending feature-flag command (one flag, or a vendor-wide batch) to both the Firebase
 * session and the backend operator identity (`appVersionPolicyMutationToken` pattern): a fresh
 * token, and the same operator before and after the refresh.
 */
export async function featureFlagMutationToken(uid: string, backendId: string): Promise<string> {
  const user = auth.currentUser;
  if (!user || user.uid !== uid) throw new Error("Your sign-in changed. Reopen this dialog.");
  const result = await user.getIdTokenResult(true);
  const claims = parseClaims(result);
  if (auth.currentUser?.uid !== uid || claims.backendId !== backendId || !isAdminToken(claims)) {
    throw new Error("Your operator access changed. Reopen this dialog before continuing.");
  }
  return result.token;
}
